/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserQuestionStatusSendOrder } from './UserQuestionStatusSendOrder';
import {
    UserQuestionStatusSendOrderFromJSON,
    UserQuestionStatusSendOrderFromJSONTyped,
    UserQuestionStatusSendOrderToJSON,
} from './UserQuestionStatusSendOrder';

/**
 * 
 * @export
 * @interface UserQuestion
 */
export interface UserQuestion {
    /**
     * 
     * @type {string}
     * @memberof UserQuestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserQuestion
     */
    title: string;
    /**
     * 
     * @type {UserQuestionStatusSendOrder}
     * @memberof UserQuestion
     */
    statusSendOrder: UserQuestionStatusSendOrder;
}

/**
 * Check if a given object implements the UserQuestion interface.
 */
export function instanceOfUserQuestion(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "statusSendOrder" in value;

    return isInstance;
}

export function UserQuestionFromJSON(json: any): UserQuestion {
    return UserQuestionFromJSONTyped(json, false);
}

export function UserQuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserQuestion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'statusSendOrder': UserQuestionStatusSendOrderFromJSON(json['statusSendOrder']),
    };
}

export function UserQuestionToJSON(value?: UserQuestion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'statusSendOrder': UserQuestionStatusSendOrderToJSON(value.statusSendOrder),
    };
}

